import { memo, useMemo } from 'react'
import { Checkbox, Empty, Flex, Table, Typography } from 'antd'
import { useIntl } from 'react-intl'
import NoRecordsFound from '../../../../common/NoRecordsFound'
import {
  useMappedContext,
  SELECT_DESELECT_MAPPED,
} from '../context/context'
import { emptyStateStyle } from '../useTableScrollY'
import RecordsCount from '../../../../common/RecordsCount'
import EllipsisTooltip from '../../../../common/EllipsisTooltip'

const MappedRow = memo(({ row, isChecked, onToggle }) => (
  <Flex gap={12} align="flex-start">
    <Checkbox
      checked={isChecked}
      onChange={onToggle}
    />
    <Flex vertical gap={0} style={{ width: 'calc(100% - 30px)'}}>
      <Typography.Text className='bolder'><EllipsisTooltip className='ellipsis'>{row.name}</EllipsisTooltip></Typography.Text>
      <Typography.Text><EllipsisTooltip className='ellipsis'>{row.description}</EllipsisTooltip></Typography.Text>
    </Flex>
  </Flex>
))

const MappedConnectorsTable = ({ rows, scrollY }) => {
  const [state, dispatch] = useMappedContext()
  const intl = useIntl()

  const columns = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: 'functionalDiagram.connectors' }),
        dataIndex: 'name',
        sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
        render: (_, row) => (
          <MappedRow
            row={row}
            isChecked={state.selectedMappedIds.includes(row.connector_data_id)}
            onToggle={() =>
              dispatch({
                type: SELECT_DESELECT_MAPPED,
                data: row.connector_data_id,
              })
            }
          />
        ),
      },
    ],
    [state.selectedMappedIds, dispatch, intl]
  )

  return (
    <Table
      rowKey="connector_data_id"
      columns={columns}
      dataSource={rows}
      pagination={false}
      showSorterTooltip={false}
      scroll={{ y: scrollY > 0 ? scrollY : undefined }}
      locale={{
        emptyText: (
          <div style={emptyStateStyle(scrollY)}>
            <Empty description={<RecordsCount count={0} />} />
          </div>
        )
      }}
    />
  )
}

export default memo(MappedConnectorsTable)
